import { Link } from 'react-router-dom';
import './style.scss';
import { ConfigurationService } from '../../../../../services/configuration.service';
import { TranslationService } from '../../../../../services/translation.service';
import type ExerciseApiModel from '../../../models/exercise.api-model';
import type LegResultApiModel from '../../../models/leg-result.api-model';
import type { ILeg } from '../../../../../models/pa-egna-ben/leg.model';
import { Role } from '../../../../../models/pa-egna-ben/role.enum';
import { StepState } from './step-state.enum';
import penIcon from '../../../../../../assets/icons/pen-default-blue-1000.svg';
import DataUrlHelper from '../../../../../helpers/data-url.helper';

function FutureLeg({ step, competitionLegs }: { step: number; competitionLegs: ILeg[] }) {
  return <span>Startar {competitionLegs[step - 1].startTime.toLocaleString({ day: 'numeric', month: 'long' })}</span>;
}

const contactLink = ConfigurationService.get('paegnaben.teacherpage.contactlink');
const contactLinkText = TranslationService.get('paegnaben.teacherpage.contactlinktext');

function LegStep({
  step,
  participationId,
  legResult,
  stepState,
  exercises,
  competitionLegs,
  viewerRole = Role.anonymous,
}: {
  step: number;
  participationId: number;
  legResult: LegResultApiModel;
  stepState: StepState;
  exercises?: ExerciseApiModel[];
  competitionLegs: ILeg[];
  viewerRole?: Role;
}) {
  const legCompletedExercises: ExerciseApiModel[] = [];
  if (exercises && legResult) {
    legCompletedExercises.push(...exercises.filter((exercise) => legResult.completedExercises.includes(exercise.id)));
  }

  const legReportMissing = !legResult && stepState === StepState.Done;

  return (
    <div>
      <div className={`leg-indicator-bar-dot-wrapper leg-indicator-bar-dot-wrapper--${stepState} ${step === 5 ? 'leg-indicator-bar-dot-wrapper--bottom' : ''}`}>
        <span className={`h4${viewerRole === Role.municipalityAdministrator && legReportMissing ? ' warning' : ''}`}>Etapp {step}</span>
        <div className={step === 5 ? 'pb-0' : 'pb-3'}>
          {viewerRole !== Role.anonymous && (
            <div>
              {(legResult || (viewerRole === Role.municipalityAdministrator && stepState === StepState.Done)) && (
                <div>
                  <span className={legResult ? '' : 'exclamation-circle'}>{legResult ? legResult.weightedScore.toString() : '0'} poäng</span>
                </div>
              )}
              {legReportMissing && viewerRole === Role.teacher && (
                <div>
                  <div>Poäng saknas</div>
                  {contactLink && contactLinkText && (
                    <div>
                      <a href={contactLink}>{contactLinkText}</a>&nbsp;om du glömt rapportera
                    </div>
                  )}
                </div>
              )}
              {viewerRole === Role.municipalityAdministrator && stepState === StepState.Done && (
                <Link to={`/klasser/${participationId}/etapp/${step}/rapportera-poang`} className="my-1">
                  <img src={DataUrlHelper.encode(penIcon)} alt="" className="me-1" />
                  Redigera
                </Link>
              )}
              {competitionLegs && !legResult && stepState === StepState.Active && (
                <div>
                  <div>Rapportering öppen till och med {competitionLegs[step - 1].endTime.toLocaleString({ day: 'numeric', month: 'long' })}</div>
                  <Link to={`/klasser/${participationId}/etapp/${step}/rapportera-poang`} className="btn btn-secondary my-1">
                    Rapportera
                  </Link>
                </div>
              )}
              {competitionLegs && stepState === StepState.Future && <FutureLeg step={step} competitionLegs={competitionLegs} />}
            </div>
          )}
          {viewerRole === Role.anonymous && (
            <div>
              {legResult && legCompletedExercises && legCompletedExercises.length > 0 && (
                <ul>
                  {legCompletedExercises.map((exercise) => (
                    <li key={exercise.id}>
                      <a href={exercise.url}>{exercise.name}</a>
                    </li>
                  ))}
                </ul>
              )}
              {competitionLegs && !legResult && stepState === StepState.Active && <span>Pågår till och med {competitionLegs[step - 1].endTime.toLocaleString({ day: 'numeric', month: 'long' })}</span>}
              {competitionLegs && stepState === StepState.Future && <FutureLeg step={step} competitionLegs={competitionLegs} />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LegStep;
